import React, { useEffect } from "react";
import PaymentPageHeader from "../../Component/PaymentPageHeader/PaymentPageHeader.jsx";
import PaymentPageSidebar from "../../Component/PaymentPageSidebar/PaymentPageSidebar.jsx";
import Footer from "../../Component/Footer/Footer.jsx";
import LedgerService from "./LedgerService.js";
import { WALLET_TYPE } from "../../Constant.js";
import { RingLoader } from "react-spinners";

const Ledger = () => {
  const {
    getBalanceUser,
    balanceData,
    toggleSearch,
    showSearch,
    toDate,
    setToDate,
    fromDate,
    setFromDate,
    getLedgerReport,
    handleInputChange,
    searchInputs,
    ledgerReportData,
    loading,
    itemsPerPage,
    currentPage,
    setCurrentPage,
  } = LedgerService();

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = ledgerReportData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(ledgerReportData.length / itemsPerPage);

  useEffect(() => {
    getBalanceUser();
    getLedgerReport();
  }, []);

  return (
    <>
      <PaymentPageHeader />
      <div className="main-container">
        <div className="main-wrapper">
          <PaymentPageSidebar />
          <div className="main-content ">
            <div className="transactions-web-wrapper">
              <div className="header-section">
                <p className="transactions-heading">Ledger &amp; Balances</p>
              </div>
              <div className="balances-segment">
                <div className="transaction-utility-wrapper ">
                  <div className="transaction-utility show-dropdown">
                    <img
                      className="utility-logo"
                      src="https://pwa-cdn.freecharge.in/pwa-static/pwa/images/transactionsHistory/wallet.svg"
                      alt="wallet-icon"
                    />
                    <div className="utility-wrapper">
                      {Object.keys(WALLET_TYPE)?.map((key) => {
                        if (!balanceData?.[key]) return null;

                        let balanceKey = "";
                        if (key === "isBalance") {
                          balanceKey = "balance";
                        } else if (key === "isBBalance") {
                          balanceKey = "bBalance";
                        } else if (key === "isCBalance") {
                          balanceKey = "cBalance";
                        } else if (key === "isUBalance") {
                          balanceKey = "uBalance";
                        } else if (key === "isIDBalance") {
                          balanceKey = "idBalnace";
                        } else if (key === "isPacakgeBalance") {
                          balanceKey = "pacakgeBalance";
                        }

                        const amount = balanceData?.[balanceKey] || 0;

                        return (
                          <div className="utility-upper-section" key={key}>
                            <div className="utility-heading-wrapper">
                              <div className="utility-heading dropdown">
                                <span className="utility-title">
                                  {WALLET_TYPE[key]}
                                </span>
                              </div>
                            </div>
                            <div className="utility-right-content">
                              <div className="content">
                                ₹{amount.toFixed(2)}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  <div className="transaction-utility show-dropdown  "></div>
                  <div className="transaction-utility   last-shown-element"></div>
                </div>
              </div>
              <div className="transactions-table-container">
                <div className="head-section">
                  <p className="payment-heading">Wallet History</p>
                  <div className="right-items">
                    <div className="tooltip-wrapper search-transaction-tooltip">
                      <span
                        className="tooltip-label"
                        onClick={toggleSearch}
                        style={{ cursor: "pointer" }}
                      >
                        <img
                          src="https://pwa-cdn.freecharge.in/pwa-static/pwa/images/transactionsHistory/search-icon.svg"
                          alt="search"
                          className="search"
                        />
                      </span>
                    </div>
                  </div>
                </div>

                {showSearch && (
                  <div className="bill-payment-filter">
                    <div className="search-container">
                      <div className="search-wraper">
                        <div className="search-input">
                          <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper">
                            <div className="sc-bf9dbd6b-1 dvWaXF input-container">
                              <input
                                type="text"
                                className="sc-bf9dbd6b-4 gnaymJ"
                                placeholder="Transaction ID"
                                autoComplete="off"
                                name="transactionID"
                                value={searchInputs.transactionID}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="search-input">
                          <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper">
                            <div className="sc-bf9dbd6b-1 dvWaXF input-container">
                              <input
                                type="text"
                                className="sc-bf9dbd6b-4 gnaymJ"
                                placeholder="Account No"
                                autoComplete="off"
                                name="accountNo"
                                value={searchInputs.accountNo}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="search-input">
                          <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper">
                            <div className="sc-bf9dbd6b-1 dvWaXF input-container">
                              <label>From Date</label>
                              <input
                                type="date"
                                value={fromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="search-input">
                          <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper">
                            <div className="sc-bf9dbd6b-1 dvWaXF input-container">
                              <label>To Date</label>
                              <input
                                type="date"
                                value={toDate}
                                onChange={(e) => setToDate(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="search-input">
                          <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper">
                            <div className="sc-bf9dbd6b-1 dvWaXF input-container">
                              <button
                                type="button"
                                class="cus-kyc-btn btn-sm cus-kyc-btn-outline-secondary"
                                onClick={() => getLedgerReport()}
                              >
                                Search
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div
                  style={{
                    overflowX: "auto",
                    overflowY: "auto",
                    maxHeight: "400px",
                  }}
                >
                  <table className="transactions-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>TransactionID</th>
                        <th>UserId</th>
                        <th>Debit</th>
                        <th>Credit</th>
                        <th>Balance</th>
                        <th>Date</th>
                        <th>Description</th>
                      </tr>
                    </thead>

                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="8">
                            <div className="loader">
                              <RingLoader color="#5a6876" size={50} />
                            </div>
                          </td>
                        </tr>
                      ) : currentData?.length > 0 ? (
                        currentData.map((item, index) => (
                          <tr className="transaction-item" key={index}>
                            <td>
                              {(currentPage - 1) * itemsPerPage + index + 1}
                            </td>
                            <td>{item?.tid || "N/A"}</td>
                            <td>{item?.userID || "N/A"}</td>
                            <td>{item?.debit || "N/A"}</td>
                            <td>{item?.credit || "N/A"}</td>
                            <td>{item?.curentBalance || "N/A"}</td>
                            <td>{item?.entryDate || "N/A"}</td>
                            <td>{item?.description || "N/A"}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8" style={{ textAlign: "center" }}>
                            !!! &#128528; &#128528; No Data found &#128528;
                            &#128528;!!!
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="pagination-buttons">
                  <ul class="pagination">
                    <li class="page-item">
                      <button
                        onClick={() =>
                          setCurrentPage((p) => Math.max(1, p - 1))
                        }
                        disabled={currentPage === 1}
                      >
                        Previous
                      </button>
                    </li>
                    <li class="page-item">
                      <div>
                        {currentPage} of {totalPages}
                      </div>
                    </li>
                    <li class="page-item">
                      <button
                        onClick={() =>
                          setCurrentPage((p) => Math.min(totalPages, p + 1))
                        }
                        disabled={currentPage === totalPages}
                      >
                        Next
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Ledger;
